import { useQuery } from 'react-query';

import { Webeditor } from '../../type';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';


export const getAllWebeditor = async (): Promise<Webeditor[]> => {
    const { data } = await axios.get(`v1/get-products-for-home`);
    return data.products;
};

type QueryFnType = typeof getAllWebeditor;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useWebeditor = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['webeditor'],
        queryFn: () => getAllWebeditor(),
    });
};
